;(function () {
  var CART_REC_MAX_PRODUCTS = 12

  function shopifyStoreRootPath() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root
    }
    if (window.routes && window.routes.root) {
      return window.routes.root
    }
    return "/"
  }

  function productTypeFromCartLine(item) {
    var t = item && item.product_type
    if (t == null) return ""
    t = String(t).trim()
    return t
  }

  function dominantProductTypeInCart(items) {
    var map = new Map()
    for (var i = 0; i < items.length; i++) {
      var it = items[i]
      var type = productTypeFromCartLine(it)
      if (!type) continue
      var q = it.quantity != null ? Number(it.quantity) : 1
      if (isNaN(q) || q < 1) q = 1
      var v = it.final_line_price != null ? it.final_line_price : 0
      var cur = map.get(type) || { qty: 0, value: 0 }
      cur.qty += q
      cur.value += v
      map.set(type, cur)
    }
    if (map.size === 0) return null
    var bestType = null
    var bestQty = -1
    var bestVal = -1
    map.forEach(function (stats, type) {
      if (
        stats.qty > bestQty ||
        (stats.qty === bestQty && stats.value > bestVal)
      ) {
        bestQty = stats.qty
        bestVal = stats.value
        bestType = type
      }
    })
    return bestType
  }

  function productTypeFromHigherValueLineWhenTwo(items, cfg) {
    if (!items || items.length !== 2 || cfg.useDominantProductType === false)
      return null
    var tA = productTypeFromCartLine(items[0])
    var tB = productTypeFromCartLine(items[1])
    function lineVal(it) {
      var v = it && it.final_line_price != null ? it.final_line_price : 0
      return isNaN(v) ? 0 : v
    }
    if (tA && tB && tA !== tB) {
      return lineVal(items[0]) >= lineVal(items[1]) ? tA : tB
    }
    if (tA && tB) return tA
    return tA || tB || null
  }

  function collectProductIdsByLineValue(lines, maxSeeds) {
    var sorted = lines.slice().sort(function (a, b) {
      return b.final_line_price - a.final_line_price
    })
    var seen = new Set()
    var seeds = []
    for (var i = 0; i < sorted.length; i++) {
      if (seeds.length >= maxSeeds) break
      var pid = sorted[i].product_id
      if (seen.has(pid)) continue
      seen.add(pid)
      seeds.push(pid)
    }
    return seeds
  }

  function padSeedIdsFromRestOfCart(allItems, seeds, maxSeeds) {
    var sorted = allItems.slice().sort(function (a, b) {
      return b.final_line_price - a.final_line_price
    })
    var seen = new Set(seeds)
    for (var i = 0; i < sorted.length; i++) {
      if (seeds.length >= maxSeeds) break
      var pid = sorted[i].product_id
      if (seen.has(pid)) continue
      seen.add(pid)
      seeds.push(pid)
    }
  }

  function distinctTypesByLineValueDescending(items, maxCats) {
    var sorted = items.slice().sort(function (a, b) {
      return b.final_line_price - a.final_line_price
    })
    var out = []
    var seen = new Set()
    for (var i = 0; i < sorted.length; i++) {
      if (out.length >= maxCats) break
      var t = productTypeFromCartLine(sorted[i])
      if (!t || seen.has(t)) continue
      seen.add(t)
      out.push(t)
    }
    return out
  }

  function getRecommendationSeedProductIds(items, cfg) {
    var minLines = cfg.minLinesForTopTwo
    var maxSeeds = items.length >= minLines ? 2 : 1
    var useDom = cfg.useDominantProductType !== false

    if (items.length >= minLines && useDom) {
      var dominant = dominantProductTypeInCart(items)
      if (dominant) {
        var inDom = items.filter(function (it) {
          return productTypeFromCartLine(it) === dominant
        })
        var seeds = collectProductIdsByLineValue(inDom, maxSeeds)
        if (seeds.length < maxSeeds) {
          padSeedIdsFromRestOfCart(items, seeds, maxSeeds)
        }
        return { seeds: seeds }
      }
    }

    if (items.length === 2 && useDom && items.length < minLines) {
      var twoType = productTypeFromHigherValueLineWhenTwo(items, cfg)
      if (twoType) {
        var inTwo = items.filter(function (it) {
          return productTypeFromCartLine(it) === twoType
        })
        var seedsTwo = collectProductIdsByLineValue(inTwo, maxSeeds)
        if (seedsTwo.length < maxSeeds) {
          padSeedIdsFromRestOfCart(items, seedsTwo, maxSeeds)
        }
        return { seeds: seedsTwo }
      }
    }

    var sorted = items.slice().sort(function (a, b) {
      return b.final_line_price - a.final_line_price
    })
    var seen = new Set()
    var seeds = []
    for (var j = 0; j < sorted.length; j++) {
      if (seeds.length >= maxSeeds) break
      var pid2 = sorted[j].product_id
      if (seen.has(pid2)) continue
      seen.add(pid2)
      seeds.push(pid2)
    }
    return { seeds: seeds }
  }

  function fetchShopifyCollectionPageJson(handle, limit, page, sortBy) {
    var base = shopifyStoreRootPath()
    var pg = page != null ? Number(page) : 1
    if (isNaN(pg) || pg < 1) pg = 1
    var url =
      base +
      "collections/" +
      encodeURIComponent(handle) +
      "/products.json?limit=" +
      limit +
      "&page=" +
      pg
    if (sortBy) {
      url += "&sort_by=" + encodeURIComponent(sortBy)
    }
    return fetch(url).then(function (r) {
      return r.json()
    })
  }

  function fetchShopifyCollectionProductsPaged(
    handle,
    perPage,
    maxPages,
    sortBy
  ) {
    var pages = Math.max(1, Number(maxPages) || 1)
    var req = []
    for (var p = 1; p <= pages; p++) {
      req.push(
        fetchShopifyCollectionPageJson(handle, perPage, p, sortBy).catch(
          function () {
            return { products: [] }
          }
        )
      )
    }
    return Promise.all(req).then(function (batches) {
      var lists = batches.map(function (b) {
        return (b && b.products) || []
      })
      return mergeUniqueProductsFromLists(lists)
    })
  }

  function fetchShopifyRelatedForProductId(productId, limit) {
    var base = shopifyStoreRootPath()
    var pid = Number(productId)
    if (isNaN(pid) || pid < 1) return Promise.resolve([])
    var lim = Number(limit)
    if (isNaN(lim) || lim < 1) lim = 10
    var url =
      base +
      "recommendations/products.json?product_id=" +
      encodeURIComponent(pid) +
      "&limit=" +
      encodeURIComponent(lim) +
      "&intent=related"
    return fetch(url)
      .then(function (r) {
        return r.json()
      })
      .then(function (data) {
        return (data && data.products) || []
      })
      .catch(function () {
        return []
      })
  }

  function mergeRelatedProductsFromSeedIds(seedIds, perSeedLimit) {
    var seeds = Array.isArray(seedIds) ? seedIds : []
    if (!seeds.length) return Promise.resolve([])
    var req = seeds.map(function (sid) {
      return fetchShopifyRelatedForProductId(sid, perSeedLimit || 12)
    })
    return Promise.all(req).then(function (lists) {
      return mergeUniqueProductsFromLists(lists)
    })
  }

  function toProductIdArray(products) {
    var out = []
    for (var i = 0; i < products.length; i++) {
      var p = products[i]
      if (p && p.id != null) out.push(Number(p.id))
    }
    return out
  }

  function getBestsellerIdOrderForHandle(handle, pages) {
    return fetchShopifyCollectionProductsPaged(
      handle,
      250,
      pages || 1,
      "best-selling"
    )
      .then(function (list) {
        return toProductIdArray(list || [])
      })
      .catch(function () {
        return []
      })
  }

  function resolveBestsellerIdsForCategoryOrStore(categoryType, staticBestIds) {
    var fallbackStatic = staticBestIds || []
    var candidates = collectionHandlesFromProductType(categoryType)

    function tryCandidate(idx) {
      if (idx >= candidates.length) {
        return getBestsellerIdOrderForHandle("all", 2).then(function (
          globalIds
        ) {
          return globalIds.length ? globalIds : fallbackStatic
        })
      }
      return getBestsellerIdOrderForHandle(candidates[idx], 2).then(function (
        ids
      ) {
        if (ids.length) return ids
        return tryCandidate(idx + 1)
      })
    }

    if (!categoryType) {
      return getBestsellerIdOrderForHandle("all", 2).then(function (globalIds) {
        return globalIds.length ? globalIds : fallbackStatic
      })
    }

    return tryCandidate(0)
  }

  function fetchBestsellingProductsForCategoryHandles(categoryType, pages) {
    var candidates = collectionHandlesFromProductType(categoryType)
    if (!candidates.length) return Promise.resolve([])

    function tryCandidate(idx) {
      if (idx >= candidates.length) return Promise.resolve([])
      return fetchShopifyCollectionProductsPaged(
        candidates[idx],
        250,
        pages || 2,
        "best-selling"
      )
        .then(function (list) {
          if (list && list.length) return list
          return tryCandidate(idx + 1)
        })
        .catch(function () {
          return tryCandidate(idx + 1)
        })
    }

    return tryCandidate(0)
  }

  function priceForRanking(p) {
    if (!p) return 0
    var variants = p.variants
    if (variants && variants.length) {
      var max = 0
      var found = false
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i]
        if (v.available !== true) continue
        found = true
        var pr = parseFloat(v.price)
        if (!isNaN(pr) && pr > max) max = pr
      }
      if (found && max > 0) return max
    }
    var fallback = parseFloat(p.price)
    return isNaN(fallback) ? 0 : fallback
  }

  function indexInBestsellerList(productId, bestSellerIds) {
    if (!bestSellerIds || !bestSellerIds.length) return 999999
    var id = Number(productId)
    for (var i = 0; i < bestSellerIds.length; i++) {
      if (Number(bestSellerIds[i]) === id) return i
    }
    return 999999
  }

  function hasAvailableVariant(p) {
    if (!p) return false
    if (p.available === true) return true
    if (p.available === false) return false
    var variants = p.variants
    if (variants && variants.length) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available === true) return true
      }
    }
    return false
  }

  function compareBestsellerRankThenPrice(a, b, bestSellerIds) {
    var ra = indexInBestsellerList(a.id, bestSellerIds)
    var rb = indexInBestsellerList(b.id, bestSellerIds)
    if (ra !== rb) return ra - rb
    return priceForRanking(b) - priceForRanking(a)
  }
  function compareStockThenBestsellerRank(a, b, bestSellerIds) {
    var aAvail = hasAvailableVariant(a)
    var bAvail = hasAvailableVariant(b)
    if (aAvail !== bAvail) return aAvail ? -1 : 1
    if (!aAvail && !bAvail) {
      return priceForRanking(b) - priceForRanking(a)
    }
    return compareBestsellerRankThenPrice(a, b, bestSellerIds)
  }

  function filterInStockExcludingCart(products, cartProductIds, bestSellerIds) {
    return products
      .filter(function (p) {
        return p && !cartProductIds.has(p.id) && hasAvailableVariant(p)
      })
      .sort(function (a, b) {
        return compareBestsellerRankThenPrice(a, b, bestSellerIds)
      })
  }

  function filterExcludingCartAllowSoldOut(
    products,
    cartProductIds,
    bestSellerIds
  ) {
    return products
      .filter(function (p) {
        return p && !cartProductIds.has(p.id)
      })
      .sort(function (a, b) {
        return compareStockThenBestsellerRank(a, b, bestSellerIds)
      })
  }

  function mergeUniqueProductsFromLists(arrays) {
    var map = new Map()
    for (var a = 0; a < arrays.length; a++) {
      var list = arrays[a] || []
      for (var i = 0; i < list.length; i++) {
        var p = list[i]
        if (p && p.id != null && !map.has(p.id)) map.set(p.id, p)
      }
    }
    return Array.from(map.values())
  }

  function normalizeForCategoryMatch(s) {
    if (s == null || s === "") return ""
    return String(s)
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s*>\s*/g, ">")
      .replace(/\s*\/\s*/g, "/")
      .replace(/\s*\|\s*/g, "|")
  }

  function toComparableWordString(s) {
    if (s == null || s === "") return ""
    return String(s)
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim()
  }

  function pathSegmentsFromCategory(s) {
    var base = normalizeForCategoryMatch(s)
    if (!base) return []
    return base
      .split(/[>\/|]+/)
      .map(function (x) {
        return toComparableWordString(x)
      })
      .filter(Boolean)
  }

  function segmentToCollectionSlug(s) {
    var t = toComparableWordString(s)
    if (!t) return ""
    return t.replace(/\s+/g, "-")
  }

  function collectionHandlesFromProductType(categoryTypeRaw) {
    var parts = pathSegmentsFromCategory(categoryTypeRaw)
    var out = []
    var seen = new Set()

    function push(h) {
      if (!h || seen.has(h)) return
      seen.add(h)
      out.push(h)
    }

    if (!parts.length) return out

    var slugParts = parts
      .map(function (p) {
        return segmentToCollectionSlug(p)
      })
      .filter(Boolean)

    var full = slugParts.join("-")
    push(full)

    for (var i = slugParts.length - 1; i >= 0; i--) {
      push(slugParts.slice(i).join("-"))
      push(slugParts[i])
    }

    return out
  }

  function strictOrHierarchicalTypeMatch(productTypeRaw, categoryTypeRaw) {
    var prod = normalizeForCategoryMatch(productTypeRaw)
    var cat = normalizeForCategoryMatch(categoryTypeRaw)
    if (!cat) return true
    if (!prod) return false
    if (prod === cat) return true
    if (cat.startsWith(prod + ">")) return true
    if (prod.startsWith(cat + ">")) return true

    var catParts = pathSegmentsFromCategory(cat)
    var prodParts = pathSegmentsFromCategory(prod)
    var catLast = catParts.length ? catParts[catParts.length - 1] : ""
    var prodLast = prodParts.length ? prodParts[prodParts.length - 1] : ""
    if (catLast && prodLast && catLast === prodLast) return true

    return false
  }

  function filterProductsMatchingCategory(products, categoryType) {
    if (!categoryType) return products
    return products.filter(function (p) {
      return strictOrHierarchicalTypeMatch(p && p.product_type, categoryType)
    })
  }

  function parentCategoryPathString(categoryTypeRaw) {
    var parts = pathSegmentsFromCategory(categoryTypeRaw)
    if (parts.length <= 1) return null
    return parts.slice(0, parts.length - 1).join(">")
  }

  function filterProductsMatchingCategoryRootWord(products, categoryTypeRaw) {
    var parts = pathSegmentsFromCategory(categoryTypeRaw)
    if (!parts.length) return []
    var root = parts[0]
    if (!root) return []
    return (products || []).filter(function (p) {
      var pt = toComparableWordString(p && p.product_type)
      return !!pt && pt.indexOf(root) !== -1
    })
  }

  var FALLBACK_GENERIC_TYPE_TOKENS = {
    eu: true,
    product: true,
    products: true,
    produse: true,
    produs: true,
    cadouri: true,
    cadou: true,
    gift: true,
    gifts: true,
    default: true,
    new: true,
    nou: true,
    vanatoare: true,
    vanator: true,
    vanatori: true,
    motive: true,
    model: true,
    modele: true,
  }

  function isGenericTypeToken(t) {
    return FALLBACK_GENERIC_TYPE_TOKENS[t] === true
  }

  function typesAreLooselySimilar(productTypeRaw, cartTypeRaw) {
    if (!cartTypeRaw || !productTypeRaw) return false
    if (strictOrHierarchicalTypeMatch(productTypeRaw, cartTypeRaw)) return true

    var catLoose = toComparableWordString(cartTypeRaw)
    var prodLoose = toComparableWordString(productTypeRaw)
    if (!catLoose || !prodLoose) return false

    if (
      prodLoose.indexOf(catLoose) !== -1 ||
      catLoose.indexOf(prodLoose) !== -1
    ) {
      return true
    }

    var catToks = catLoose.split(/\s+/).filter(function (t) {
      return t.length > 2 && !isGenericTypeToken(t)
    })
    var prodToks = prodLoose.split(/\s+/).filter(function (t) {
      return t.length > 2 && !isGenericTypeToken(t)
    })
    if (!catToks.length || !prodToks.length) return false

    var catSet = {}
    for (var i = 0; i < catToks.length; i++) catSet[catToks[i]] = true
    for (var j = 0; j < prodToks.length; j++) {
      if (catSet[prodToks[j]]) return true
    }
    return false
  }

  function preferSimilarTypesInBestsellers(
    sortedBestsellers,
    primaryCategory,
    maxProducts
  ) {
    var m = Number(maxProducts)
    if (isNaN(m) || m < 1) m = 5
    var list = sortedBestsellers || []
    if (!primaryCategory) {
      return list.slice(0, m)
    }
    var similar = list.filter(function (p) {
      return typesAreLooselySimilar(p && p.product_type, primaryCategory)
    })
    if (similar.length > 0) {
      return similar.slice(0, m)
    }
    return list.slice(0, m)
  }

  function fillToLimitWithSimilarTypes(
    existingResults,
    sortedPool,
    primaryCategory,
    maxProducts
  ) {
    var m = Number(maxProducts)
    if (isNaN(m) || m < 1) m = 5
    var seen = new Set()
    var out = []
    var exList = existingResults || []
    var i
    for (i = 0; i < exList.length; i++) {
      var ex = exList[i]
      if (ex && ex.id != null && !seen.has(ex.id)) {
        seen.add(ex.id)
        out.push(ex)
      }
    }
    if (!primaryCategory || out.length >= m) return out

    var pool = sortedPool || []
    for (var j = 0; j < pool.length; j++) {
      var p = pool[j]
      if (!p || seen.has(p.id)) continue
      if (!typesAreLooselySimilar(p.product_type, primaryCategory)) continue
      seen.add(p.id)
      out.push(p)
      if (out.length >= m) break
    }
    return out
  }

  function mergeProductListsDeduped(primary, secondary, maxItems) {
    var out = []
    var seen = new Set()

    function pushList(list) {
      for (var i = 0; i < list.length; i++) {
        if (maxItems && out.length >= maxItems) break
        var p = list[i]
        if (!p || p.id == null || seen.has(p.id)) continue
        seen.add(p.id)
        out.push(p)
      }
    }

    pushList(primary || [])
    pushList(secondary || [])
    return out
  }

  function sessionStorageKeyFallbackRotation() {
    return "cart-best-seller:fallback-history:v1"
  }

  function sessionStorageKeySimilarSeeds(seedIds) {
    var seeds = Array.isArray(seedIds) ? seedIds.slice() : []
    var normalized = seeds
      .map(function (x) {
        return Number(x)
      })
      .filter(function (x) {
        return !isNaN(x) && x > 0
      })
      .sort(function (a, b) {
        return a - b
      })
      .join("-")
    return "cart-best-seller:similar-history:v1:" + (normalized || "none")
  }

  function readShownProductIdsFromStorage(key) {
    try {
      var raw = window.sessionStorage
        ? window.sessionStorage.getItem(key)
        : null
      var arr = raw ? JSON.parse(raw) : []
      if (!Array.isArray(arr)) return []
      return arr
        .map(function (x) {
          return Number(x)
        })
        .filter(function (x) {
          return !isNaN(x) && x > 0
        })
    } catch (e) {
      return []
    }
  }

  function writeShownProductIdsToStorage(key, ids) {
    try {
      if (!window.sessionStorage) return
      window.sessionStorage.setItem(key, JSON.stringify(ids || []))
    } catch (e) {}
  }

  function readFallbackShownIds() {
    return readShownProductIdsFromStorage(sessionStorageKeyFallbackRotation())
  }

  function writeFallbackShownIds(ids) {
    writeShownProductIdsToStorage(sessionStorageKeyFallbackRotation(), ids)
  }

  function rotateFallbackRecommendations(products, maxProducts) {
    var list = Array.isArray(products) ? products : []
    var max = Number(maxProducts)
    if (isNaN(max) || max < 1) max = 5
    if (!list.length) return list

    var history = readFallbackShownIds()
    var seen = new Set(history)
    var unseen = []
    var seenAgain = []

    for (var i = 0; i < list.length; i++) {
      var p = list[i]
      if (!p || p.id == null) continue
      if (seen.has(Number(p.id))) seenAgain.push(p)
      else unseen.push(p)
    }

    if (!unseen.length) {
      writeFallbackShownIds([])
      return list
    }

    var rotated = unseen.concat(seenAgain)
    var shownNow = rotated.slice(0, max).map(function (p) {
      return Number(p.id)
    })
    var nextHistory = history.concat(shownNow)
    if (nextHistory.length > 200) {
      nextHistory = nextHistory.slice(nextHistory.length - 200)
    }
    writeFallbackShownIds(nextHistory)
    return rotated
  }

  function rotateSimilarRecommendations(products, maxProducts, seedIds) {
    var list = Array.isArray(products) ? products : []
    var max = Number(maxProducts)
    if (isNaN(max) || max < 1) max = 5
    if (!list.length) return list

    var key = sessionStorageKeySimilarSeeds(seedIds)
    var history = readShownProductIdsFromStorage(key)
    var seen = new Set(history)
    var unseen = []
    var seenAgain = []

    for (var i = 0; i < list.length; i++) {
      var p = list[i]
      if (!p || p.id == null) continue
      if (seen.has(Number(p.id))) seenAgain.push(p)
      else unseen.push(p)
    }

    if (!unseen.length) {
      writeShownProductIdsToStorage(key, [])
      return list
    }

    var rotated = unseen.concat(seenAgain)
    var shownNow = rotated.slice(0, max).map(function (p) {
      return Number(p.id)
    })
    var nextHistory = history.concat(shownNow)
    if (nextHistory.length > 200) {
      nextHistory = nextHistory.slice(nextHistory.length - 200)
    }
    writeShownProductIdsToStorage(key, nextHistory)
    return rotated
  }

  function otherLineCategoryInTwoItemCart(cartItems, selectedCategory) {
    if (!cartItems || cartItems.length !== 2) return null
    var t0 = productTypeFromCartLine(cartItems[0])
    var t1 = productTypeFromCartLine(cartItems[1])
    if (!t0 || !t1 || t0 === t1) return null
    if (selectedCategory === t0) return t1
    if (selectedCategory === t1) return t0
    return null
  }

  function categoryFilterFromCart(cartItems, cfg) {
    var minL = cfg.minLinesForTopTwo

    if (cfg.filterByDominantCategoryOnly === false) {
      return { categoryType: null, mode: "no_filter" }
    }

    if (cartItems.length === 1) {
      var tOne = productTypeFromCartLine(cartItems[0])
      if (tOne) {
        return { categoryType: tOne, mode: "single_product" }
      }
      return { categoryType: null, mode: "price_fallback" }
    }

    if (cartItems.length === 2 && cfg.useDominantProductType !== false) {
      var twoCat = productTypeFromHigherValueLineWhenTwo(cartItems, cfg)
      if (twoCat) {
        return { categoryType: twoCat, mode: "dominant" }
      }
      return { categoryType: null, mode: "price_fallback" }
    }

    if (cartItems.length < minL) {
      return { categoryType: null, mode: "small_cart" }
    }

    if (cfg.useDominantProductType === false) {
      return { categoryType: null, mode: "no_filter" }
    }

    var d = dominantProductTypeInCart(cartItems)
    if (d) {
      return { categoryType: d, mode: "dominant" }
    }
    return { categoryType: null, mode: "price_fallback" }
  }

  function tearDownSlickCarouselsIn(container) {
    if (!window.jQuery) return
    var $ = window.jQuery
    container
      .querySelectorAll(".products-carousel.slick-initialized")
      .forEach(function (el) {
        try {
          $(el).slick("unslick")
        } catch (e) {}
      })
  }

  function fetchAjaxProductCardMarkup(handle) {
    var base = shopifyStoreRootPath()
    return fetch(
      base + "products/" + encodeURIComponent(handle) + "?view=ajax_card"
    ).then(function (r) {
      return r.text()
    })
  }

  function moveProductInfoAboveAddToCart(carousel) {
    if (!carousel || !carousel.querySelectorAll) return
    carousel.querySelectorAll(".product-item .card").forEach(function (card) {
      var info = card.querySelector(".card-information")
      var wrapper = card.querySelector(".card-product__wrapper")
      var action = card.querySelector(".card-action")
      if (!info || !wrapper) return
      if (
        action &&
        info.parentNode === wrapper &&
        action.previousElementSibling === info
      ) {
        return
      }
      if (action) {
        wrapper.insertBefore(info, action)
        return
      }
      if (info.parentNode === wrapper) return
      var media = wrapper.querySelector(".card-media")
      if (media && media.nextSibling) {
        wrapper.insertBefore(info, media.nextSibling)
      } else {
        wrapper.appendChild(info)
      }
    })
  }

  function attachInventoryDataToCarouselCards(scope) {
    if (!window.jQuery || !window.routes || !window.routes.root) return
    var $ = window.jQuery
    $(scope)
      .find(".product-item")
      .each(function () {
        var product = $(this)
        var productId = product.data("product-id")
        var productJson = product.data("json-product")
        if (!productJson || !productJson.handle) return
        $.ajax({
          type: "get",
          url:
            window.routes.root +
            "/products/" +
            productJson.handle +
            "?view=ajax_variant_quantity",
          success: function (data) {
            var element = new DOMParser().parseFromString(data, "text/html")
            var q = element.querySelector(
              '[data-quantity-product-id="' + productId + '"]'
            )
            if (q) {
              window["quick_view_inven_array_" + productId] = JSON.parse(
                q.innerHTML
              )
            }
          },
        })
      })
  }

  function mountCartBestSellerSkeletonFromTemplate(root, contentEl) {
    if (!contentEl || !root) return
    var id = root.getAttribute("data-skeleton-template-id")
    if (!id) return
    var tpl = document.getElementById(id)
    if (!tpl || !tpl.content) return
    if (
      window.jQuery &&
      window.jQuery.fn.slick &&
      window.jQuery(contentEl).hasClass("slick-initialized")
    ) {
      try {
        window.jQuery(contentEl).slick("unslick")
      } catch (eSk) {}
    }
    contentEl.innerHTML = ""
    contentEl.appendChild(tpl.content.cloneNode(true))
    contentEl.setAttribute("aria-busy", "true")
  }

  function clearCartBestSellerContentBusy(contentEl) {
    if (contentEl) contentEl.removeAttribute("aria-busy")
  }

  function cfgSliderBool(cfg, key, defVal) {
    if (cfg[key] === undefined || cfg[key] === null) return defVal
    return cfg[key] === true || cfg[key] === "true"
  }

  /**
   * Quick-cart drawer: dots + arrows at all viewport widths.
   * mobileFirst: viewport under 768px → 2 products per slide; 768px+ → 1 per slide.
   */
  function initQuickCartDrawerSlick(carousel, cfg) {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return
    var $g = window.jQuery(carousel)
    if ($g.hasClass("slick-initialized")) {
      try {
        $g.slick("unslick")
      } catch (e) {}
    }
    var dots = cfgSliderBool(cfg, "sliderDots", true)
    var arr = cfgSliderBool(cfg, "sliderArrows", true)
    var prevA =
      window.arrows && window.arrows.icon_prev
        ? window.arrows.icon_prev
        : undefined
    var nextA =
      window.arrows && window.arrows.icon_next
        ? window.arrows.icon_next
        : undefined
    $g.slick({
      mobileFirst: true,
      adaptiveHeight: false,
      infinite: false,
      vertical: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      dots: dots,
      arrows: arr,
      prevArrow: prevA,
      nextArrow: nextA,
      rtl: !!window.rtl_slick,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    })
    scheduleQuickCartDrawerSlickRefresh()
  }

  var drawerSlickObserverBound = false

  function scheduleQuickCartDrawerSlickRefresh() {
    function fix() {
      if (!window.jQuery || !window.jQuery.fn.slick) return
      window
        .jQuery("#halo-cart-sidebar .products-carousel.slick-initialized")
        .each(function () {
          try {
            window.jQuery(this).slick("setPosition")
          } catch (e) {}
        })
    }
    if (typeof requestAnimationFrame !== "undefined") {
      requestAnimationFrame(function () {
        requestAnimationFrame(fix)
      })
    } else {
      setTimeout(fix, 0)
    }
    setTimeout(fix, 200)
    setTimeout(fix, 500)
  }

  function bindCartDrawerSlickOnOpenOnce() {
    if (drawerSlickObserverBound) return
    if (typeof MutationObserver === "undefined") return
    drawerSlickObserverBound = true
    var obs = new MutationObserver(function () {
      if (!document.body.classList.contains("cart-sidebar-show")) return
      scheduleQuickCartDrawerSlickRefresh()
    })
    obs.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    })
  }

  /**
   * Cart page product-block: after productBlockSilder(), recalc Slick layout so arrows
   * advance slides correctly (section may have been hidden or width was 0 at first init).
   */
  function scheduleCartPageProductBlockSlickRefresh($wrap) {
    if (!$wrap || !$wrap.length || !window.jQuery || !window.jQuery.fn.slick)
      return
    function fix() {
      $wrap.find(".products-carousel.slick-initialized").each(function () {
        try {
          window.jQuery(this).slick("setPosition")
        } catch (e) {}
      })
    }
    if (typeof requestAnimationFrame !== "undefined") {
      requestAnimationFrame(function () {
        requestAnimationFrame(fix)
      })
    } else {
      setTimeout(fix, 0)
    }
    setTimeout(fix, 150)
    setTimeout(fix, 450)
    try {
      window.jQuery(window).trigger("resize")
    } catch (e2) {}
  }

  function renderProductRecommendationsCarousel(products, cfg, contentEl) {
    var slice = products.slice(0, cfg.maxProducts)
    var bestSet = new Set(cfg.bestSellerProductIds || [])

    return Promise.all(
      slice.map(function (p) {
        return fetchAjaxProductCardMarkup(p.handle).then(
          function (html) {
            return { product: p, html: html }
          },
          function () {
            return null
          }
        )
      })
    )
      .then(function (rows) {
        var cols = Number(cfg.carouselColumns)
        if (isNaN(cols) || cols < 1) cols = 4
        cols = Math.min(5, Math.max(1, cols))

        var dots = cfgSliderBool(cfg, "sliderDots", true)
        var dotsMb = cfgSliderBool(cfg, "sliderDotsMb", true)
        var arr = cfgSliderBool(cfg, "sliderArrows", true)
        var arrMb = cfgSliderBool(cfg, "sliderArrowsMb", false)
        var enProg = cfgSliderBool(cfg, "enableProgressBar", false)
        var enCnt = cfgSliderBool(cfg, "enableCounterNumber", false)

        var inCartDrawer =
          contentEl &&
          typeof contentEl.closest === "function" &&
          !!contentEl.closest("#halo-cart-sidebar")
        var useFlatDrawerTrack =
          inCartDrawer &&
          contentEl.classList &&
          contentEl.classList.contains("previewCartCarousel")

        var carousel
        if (useFlatDrawerTrack) {
          bindCartDrawerSlickOnOpenOnce()
          carousel = contentEl
          if (window.jQuery && window.jQuery.fn.slick) {
            var $track = window.jQuery(carousel)
            if ($track.hasClass("slick-initialized")) {
              try {
                $track.slick("unslick")
              } catch (eUn) {}
            }
          }
          tearDownSlickCarouselsIn(carousel)
          while (carousel.firstChild) {
            carousel.removeChild(carousel.firstChild)
          }
          var clsFlat =
            "previewCartCarousel products-carousel cart-best-seller-content cart-best-seller-halo-block column-" +
            cols
          if (enProg) clsFlat += " enable_progress_bar"
          if (enCnt) clsFlat += " enable_counter_number"
          carousel.className = clsFlat
          carousel.setAttribute("data-item-to-show", String(cols))
          carousel.setAttribute("data-item-dots", dots ? "true" : "false")
          carousel.setAttribute("data-item-dots-mb", dotsMb ? "true" : "false")
          carousel.setAttribute("data-item-arrows", arr ? "true" : "false")
          carousel.setAttribute("data-item-arrows-mb", arrMb ? "true" : "false")
        } else {
          carousel = document.createElement("div")
          var cls = "products-carousel column-" + cols
          if (enProg) cls += " enable_progress_bar"
          if (enCnt) cls += " enable_counter_number"
          carousel.className = cls
          carousel.setAttribute("data-item-to-show", String(cols))
          carousel.setAttribute("data-item-dots", dots ? "true" : "false")
          carousel.setAttribute("data-item-dots-mb", dotsMb ? "true" : "false")
          carousel.setAttribute("data-item-arrows", arr ? "true" : "false")
          carousel.setAttribute("data-item-arrows-mb", arrMb ? "true" : "false")
        }

        for (var i = 0; i < rows.length; i++) {
          var row = rows[i]
          if (!row || !row.html) continue
          var p = row.product
          var wrap = document.createElement("div")
          wrap.className = "product"
          if (cfg.showBestsellerBadge && bestSet.has(p.id)) {
            wrap.classList.add("cart-best-seller--bestseller")
          }
          var inner = document.createElement("div")
          inner.innerHTML = row.html.trim()
          var card = inner.firstElementChild
          if (!card) continue
          wrap.appendChild(card)
          carousel.appendChild(wrap)
        }

        moveProductInfoAboveAddToCart(carousel)

        if (!useFlatDrawerTrack) {
          tearDownSlickCarouselsIn(contentEl)
          contentEl.innerHTML = ""
          contentEl.appendChild(carousel)
        }

        if (!useFlatDrawerTrack && enProg) {
          var sh =
            cfg.scrollHeightPx != null && !isNaN(Number(cfg.scrollHeightPx))
              ? Number(cfg.scrollHeightPx)
              : 4
          var track = cfg.scrollTrackBg || "#f1f1f1"
          var thumb = cfg.scrollThumbColor || "#000000"
          var thumbH = cfg.scrollThumbHoverColor || "#444444"
          var pb = document.createElement("div")
          pb.className = "slider-progress-bar"
          pb.style.setProperty("--scrollbar-height", sh + "px")
          pb.style.setProperty(
            "--scrollbar-track-color",
            track !== "rgba(0,0,0,0)" ? track : ""
          )
          pb.style.setProperty(
            "--scrollbar-thumb-color",
            thumb !== "rgba(0,0,0,0)" ? thumb : ""
          )
          pb.style.setProperty(
            "--scrollbar-thumb-hover-color",
            thumbH !== "rgba(0,0,0,0)" ? thumbH : ""
          )
          pb.innerHTML =
            '<div class="slider-scrollbar-track"><div class="scrollbar-thumb"></div></div>'
          contentEl.appendChild(pb)
        }

        if (!useFlatDrawerTrack && enCnt) {
          var totalDisp = slice.length
          var cnt = document.createElement("div")
          cnt.className = "products-counter-number"
          cnt.innerHTML =
            '<div class="counter"><span id="count-image">1</span>/' +
            totalDisp +
            "</div>"
          contentEl.appendChild(cnt)
        }

        if (useFlatDrawerTrack && window.jQuery && window.jQuery.fn.slick) {
          initQuickCartDrawerSlick(carousel, cfg)
        } else if (!useFlatDrawerTrack) {
          var $wrap =
            window.jQuery &&
            window.jQuery(contentEl).closest(".halo-product-block")
          if (
            window.jQuery &&
            window.halo &&
            typeof window.halo.productBlockSilder === "function" &&
            $wrap &&
            $wrap.length
          ) {
            window.halo.productBlockSilder($wrap)
            scheduleCartPageProductBlockSlickRefresh($wrap)
          }
        }
        attachInventoryDataToCarouselCards(contentEl)
        clearCartBestSellerContentBusy(contentEl)
      })
      .catch(function () {
        clearCartBestSellerContentBusy(contentEl)
      })
  }

  function showCartRecEmptyMessage(contentEl, cfg, text) {
    if (
      window.jQuery &&
      window.jQuery.fn.slick &&
      contentEl &&
      window.jQuery(contentEl).hasClass("slick-initialized")
    ) {
      try {
        window.jQuery(contentEl).slick("unslick")
      } catch (eEmpty) {}
    }
    contentEl.innerHTML = ""
    clearCartBestSellerContentBusy(contentEl)
    var p = document.createElement("p")
    p.className = "cart-best-seller-empty"
    p.textContent = text || cfg.emptyText || "No recommendations available."
    contentEl.appendChild(p)
  }

  /**
   * Empty cart: show section — bestsellers from fallback collection or manual list per config.
   */
  function syncEmptyCartBestsellersOnly(
    root,
    cfg,
    contentEl,
    titleEl,
    subEl,
    dominantEl,
    cartProductIds
  ) {
    root.hidden = false
    if (dominantEl) {
      dominantEl.hidden = true
      dominantEl.textContent = ""
    }
    if (subEl) {
      subEl.hidden = true
      subEl.textContent = ""
    }
    if (titleEl) {
      titleEl.textContent = cfg.headingPrimary || ""
    }
    mountCartBestSellerSkeletonFromTemplate(root, contentEl)

    if (cfg.recommendationMode === "manual") {
      var manualSrcEmpty = cfg.manualProducts || []
      var manualListEmpty = manualSrcEmpty.filter(function (p) {
        if (!p || !p.handle) return false
        var pid = Number(p.id)
        if (cartProductIds.has(pid)) return false
        return true
      })
      manualListEmpty = manualListEmpty.slice(0, cfg.maxProducts)
      if (!manualListEmpty.length) {
        showCartRecEmptyMessage(contentEl, cfg)
        return Promise.resolve()
      }
      return renderProductRecommendationsCarousel(
        manualListEmpty,
        cfg,
        contentEl
      ).then(function () {
        if (!contentEl.querySelector(".product-item")) {
          showCartRecEmptyMessage(contentEl, cfg)
        }
      })
    }

    var handle = cfg.fallbackCollectionHandle
    if (!handle || String(handle).trim() === "") {
      showCartRecEmptyMessage(contentEl, cfg)
      return Promise.resolve()
    }

    return fetchShopifyCollectionProductsPaged(
      String(handle).trim(),
      250,
      1,
      "best-selling"
    )
      .then(function (list) {
        var bestIds = toProductIdArray(list || [])
        var sorted = filterInStockExcludingCart(
          list || [],
          cartProductIds,
          bestIds
        )
        var slice = sorted.slice(0, cfg.maxProducts)
        if (!slice.length) {
          showCartRecEmptyMessage(contentEl, cfg)
          return
        }
        return renderProductRecommendationsCarousel(slice, cfg, contentEl).then(
          function () {
            if (!contentEl.querySelector(".product-item")) {
              showCartRecEmptyMessage(contentEl, cfg)
            }
          }
        )
      })
      .catch(function () {
        contentEl.innerHTML = ""
        clearCartBestSellerContentBusy(contentEl)
        var err = document.createElement("p")
        err.className = "cart-best-seller-empty"
        err.textContent = cfg.errorText || "Could not load recommendations."
        contentEl.appendChild(err)
      })
  }

  function syncCartRecommendationsFromServer(root, cfg) {
    var titleEl = root.querySelector("[data-cart-best-seller-heading]")
    var subEl = root.querySelector("[data-cart-best-seller-sub]")
    var dominantEl = root.querySelector("[data-cart-best-seller-dominant]")
    var contentEl = root.querySelector("[data-cart-best-seller-content]")

    fetch(shopifyStoreRootPath() + "cart.js")
      .then(function (r) {
        return r.json()
      })
      .then(function (cart) {
        var cartProductIds = new Set(
          (cart.items || []).map(function (item) {
            return item.product_id
          })
        )

        if (!cart.item_count) {
          return syncEmptyCartBestsellersOnly(
            root,
            cfg,
            contentEl,
            titleEl,
            subEl,
            dominantEl,
            cartProductIds
          )
        }
        root.hidden = false
        mountCartBestSellerSkeletonFromTemplate(root, contentEl)

        if (cfg.recommendationMode === "manual") {
          if (dominantEl) {
            dominantEl.hidden = true
            dominantEl.textContent = ""
          }
          if (subEl) {
            subEl.hidden = true
            subEl.textContent = ""
          }
          if (titleEl) {
            titleEl.textContent = cfg.headingPrimary || "Featured products"
          }
          var manualSrcCart = cfg.manualProducts || []
          var manualList = manualSrcCart.filter(function (p) {
            if (!p || !p.handle) return false
            var pid = Number(p.id)
            if (cartProductIds.has(pid)) return false
            return true
          })
          manualList = manualList.slice(0, cfg.maxProducts)
          if (!manualList.length) {
            contentEl.innerHTML = ""
            clearCartBestSellerContentBusy(contentEl)
            var emptyManual = document.createElement("p")
            emptyManual.className = "cart-best-seller-empty"
            emptyManual.textContent =
              cfg.emptyText || "No recommendations available."
            contentEl.appendChild(emptyManual)
            return
          }
          return renderProductRecommendationsCarousel(
            manualList,
            cfg,
            contentEl
          ).then(function () {
            if (!contentEl.querySelector(".product-item")) {
              contentEl.innerHTML = ""
              clearCartBestSellerContentBusy(contentEl)
              var noCardsMan = document.createElement("p")
              noCardsMan.className = "cart-best-seller-empty"
              noCardsMan.textContent =
                cfg.emptyText || "No recommendations available."
              contentEl.appendChild(noCardsMan)
            }
          })
        }

        var categoryCtx = categoryFilterFromCart(cart.items, cfg)
        var categoriesByValue =
          cart.items.length >= cfg.minLinesForTopTwo
            ? distinctTypesByLineValueDescending(cart.items, 2)
            : []
        var primaryCategory = categoriesByValue[0] || categoryCtx.categoryType
        var alternateTwoLineCategory =
          categoriesByValue[1] ||
          otherLineCategoryInTwoItemCart(cart.items, primaryCategory)
        if (primaryCategory) {
          categoryCtx.categoryType = primaryCategory
        }

        var seedIdsResult = getRecommendationSeedProductIds(cart.items, cfg)
        var seeds = seedIdsResult.seeds

        var staticBestIds = cfg.bestSellerProductIds || []
        var bestIdsPrimaryPromise = resolveBestsellerIdsForCategoryOrStore(
          primaryCategory,
          staticBestIds
        )
        var bestIdsSecondaryPromise = alternateTwoLineCategory
          ? resolveBestsellerIdsForCategoryOrStore(
              alternateTwoLineCategory,
              staticBestIds
            )
          : Promise.resolve(staticBestIds)
        var bestIdsGlobalPromise = resolveBestsellerIdsForCategoryOrStore(
          null,
          staticBestIds
        )

        return Promise.all([
          bestIdsPrimaryPromise,
          bestIdsSecondaryPromise,
          bestIdsGlobalPromise,
        ])
          .then(function (bestPair) {
            var bestIds = bestPair[0] || staticBestIds
            var bestIdsSecondary = bestPair[1] || bestIds
            var bestIdsGlobal = bestPair[2] || staticBestIds
            function applyPipeline(list) {
              var out = filterInStockExcludingCart(
                list,
                cartProductIds,
                bestIds
              )
              return filterProductsMatchingCategory(out, primaryCategory)
            }

            function applySortOnly(list) {
              return filterInStockExcludingCart(list, cartProductIds, bestIds)
            }

            function applySortOnlyGlobal(list) {
              return filterInStockExcludingCart(
                list,
                cartProductIds,
                bestIdsGlobal
              )
            }

            function buildRankedProductRecommendations(list) {
              var primaryCategoryResults = applyPipeline(list)
              if (primaryCategoryResults.length > 0) {
                var mixedWithSecondaryOrGlobal = false
                if (
                  primaryCategory &&
                  alternateTwoLineCategory &&
                  primaryCategoryResults.length < cfg.maxProducts
                ) {
                  var secondaryCategorySorted = filterInStockExcludingCart(
                    list,
                    cartProductIds,
                    bestIdsSecondary
                  )
                  var secondaryCategoryResults = filterProductsMatchingCategory(
                    secondaryCategorySorted,
                    alternateTwoLineCategory
                  )
                  primaryCategoryResults = mergeProductListsDeduped(
                    primaryCategoryResults,
                    secondaryCategoryResults,
                    cfg.maxProducts
                  )
                  mixedWithSecondaryOrGlobal =
                    secondaryCategoryResults.length > 0
                }

                if (
                  primaryCategory &&
                  primaryCategoryResults.length < cfg.maxProducts
                ) {
                  var poolForSimilar = applySortOnlyGlobal(list)
                  var beforeLen = primaryCategoryResults.length
                  primaryCategoryResults = fillToLimitWithSimilarTypes(
                    primaryCategoryResults,
                    poolForSimilar,
                    primaryCategory,
                    cfg.maxProducts
                  )
                  if (primaryCategoryResults.length > beforeLen) {
                    for (
                      var tu = beforeLen;
                      tu < primaryCategoryResults.length;
                      tu++
                    ) {
                      var tp = primaryCategoryResults[tu]
                      if (
                        tp &&
                        !strictOrHierarchicalTypeMatch(
                          tp.product_type,
                          primaryCategory
                        )
                      ) {
                        mixedWithSecondaryOrGlobal = true
                        break
                      }
                    }
                  }
                }
                return {
                  sorted: primaryCategoryResults,
                  categoryRelaxed: mixedWithSecondaryOrGlobal,
                  stockRelaxed: false,
                }
              }
              if (primaryCategory) {
                var parentCategory = parentCategoryPathString(primaryCategory)
                if (parentCategory) {
                  var parentStrict = filterProductsMatchingCategory(
                    applySortOnlyGlobal(list),
                    parentCategory
                  )
                  if (parentStrict.length > 0) {
                    return {
                      sorted: parentStrict.slice(0, cfg.maxProducts),
                      categoryRelaxed: false,
                      stockRelaxed: false,
                    }
                  }
                }

                var rootCategory = filterProductsMatchingCategoryRootWord(
                  applySortOnlyGlobal(list),
                  primaryCategory
                )
                if (rootCategory.length > 0) {
                  return {
                    sorted: rootCategory.slice(0, cfg.maxProducts),
                    categoryRelaxed: true,
                    stockRelaxed: false,
                  }
                }

                if (alternateTwoLineCategory) {
                  var secondaryFallbackSorted = filterInStockExcludingCart(
                    list,
                    cartProductIds,
                    bestIdsSecondary
                  )
                  var secondaryCategoryOnly = filterProductsMatchingCategory(
                    secondaryFallbackSorted,
                    alternateTwoLineCategory
                  )
                  if (secondaryCategoryOnly.length > 0) {
                    return {
                      sorted: secondaryCategoryOnly.slice(0, cfg.maxProducts),
                      categoryRelaxed: false,
                      stockRelaxed: false,
                    }
                  }
                }
                var similarOnlyPool = applySortOnlyGlobal(list)
                var similarOnly = fillToLimitWithSimilarTypes(
                  [],
                  similarOnlyPool,
                  primaryCategory,
                  cfg.maxProducts
                )
                if (similarOnly.length > 0) {
                  return {
                    sorted: similarOnly,
                    categoryRelaxed: true,
                    stockRelaxed: false,
                  }
                }
                return {
                  sorted: [],
                  categoryRelaxed: false,
                  stockRelaxed: false,
                }
              } else {
                var looseNoCat = applySortOnly(list)
                if (looseNoCat.length > 0) {
                  return {
                    sorted: looseNoCat,
                    categoryRelaxed: false,
                    stockRelaxed: false,
                  }
                }
              }
              var anyStock = filterExcludingCartAllowSoldOut(
                list,
                cartProductIds,
                bestIds
              )
              if (anyStock.length > 0) {
                return {
                  sorted: anyStock,
                  categoryRelaxed: !!primaryCategory,
                  stockRelaxed: true,
                }
              }
              return { sorted: [], categoryRelaxed: false, stockRelaxed: false }
            }

            return Promise.all([
              fetchShopifyCollectionProductsPaged("all", 250, 4).catch(
                function () {
                  return []
                }
              ),
              mergeRelatedProductsFromSeedIds(seeds, 14),
            ]).then(function (sources) {
              var colAll = sources[0]
              var relatedSeedProducts = sources[1] || []
              var listAll = Array.isArray(colAll)
                ? colAll
                : (colAll && colAll.products) || []
              var seedBatch =
                buildRankedProductRecommendations(relatedSeedProducts)
              var recommendationBatch =
                buildRankedProductRecommendations(listAll)
              var sorted = []

              if (seedBatch.sorted.length > 0) {
                sorted = mergeProductListsDeduped(
                  seedBatch.sorted,
                  recommendationBatch.sorted,
                  cfg.maxProducts
                )
              } else {
                sorted = recommendationBatch.sorted
              }

              if (sorted.length > 0) {
                return {
                  sorted: sorted,
                  isFallback: false,
                  seeds: seeds,
                }
              }

              return fetchBestsellingProductsForCategoryHandles(
                primaryCategory,
                2
              ).then(function (categoryList) {
                if (categoryList && categoryList.length) {
                  var categoryOnlyBatch =
                    buildRankedProductRecommendations(categoryList)
                  if (categoryOnlyBatch.sorted.length > 0) {
                    return {
                      sorted: categoryOnlyBatch.sorted,
                      isFallback: false,
                      seeds: seeds,
                    }
                  }
                }

                var fbHandle = cfg.fallbackCollectionHandle
                if (!fbHandle) {
                  if (!sorted.length && primaryCategory) {
                    var looseAllSorted = applySortOnlyGlobal(listAll)
                    sorted = preferSimilarTypesInBestsellers(
                      looseAllSorted,
                      primaryCategory,
                      cfg.maxProducts
                    )
                    if (!sorted.length) {
                      var anyAllSorted = filterExcludingCartAllowSoldOut(
                        listAll,
                        cartProductIds,
                        bestIds
                      )
                      sorted = preferSimilarTypesInBestsellers(
                        anyAllSorted,
                        primaryCategory,
                        cfg.maxProducts
                      )
                    }
                  }
                  return {
                    sorted: sorted,
                    isFallback: true,
                    seeds: seeds,
                  }
                }
                return fetchShopifyCollectionProductsPaged(
                  fbHandle,
                  250,
                  2
                ).then(function (listFb) {
                  var merged = mergeUniqueProductsFromLists([listAll, listFb])
                  var mergedBatch = buildRankedProductRecommendations(merged)
                  sorted = mergedBatch.sorted
                  if (!sorted.length && primaryCategory) {
                    var looseMergedSorted = applySortOnlyGlobal(merged)
                    sorted = preferSimilarTypesInBestsellers(
                      looseMergedSorted,
                      primaryCategory,
                      cfg.maxProducts
                    )
                    if (!sorted.length) {
                      var anyMergedSorted = filterExcludingCartAllowSoldOut(
                        merged,
                        cartProductIds,
                        bestIds
                      )
                      sorted = preferSimilarTypesInBestsellers(
                        anyMergedSorted,
                        primaryCategory,
                        cfg.maxProducts
                      )
                    }
                  }
                  return {
                    sorted: sorted,
                    isFallback: true,
                    seeds: seeds,
                  }
                })
              })
            })
          })
          .then(function (pack) {
            if (!pack || !Array.isArray(pack.sorted)) {
              pack = { sorted: [], seeds: [], isFallback: true }
            }
            if (dominantEl) {
              dominantEl.hidden = true
              dominantEl.textContent = ""
            }
            if (subEl) {
              subEl.hidden = true
              subEl.textContent = ""
            }
            if (titleEl) {
              titleEl.textContent = cfg.headingPrimary || "Featured products"
            }
            if (pack.isFallback) {
              pack.sorted = rotateFallbackRecommendations(
                pack.sorted,
                cfg.maxProducts
              )
            } else if (pack.seeds && pack.seeds.length) {
              pack.sorted = rotateSimilarRecommendations(
                pack.sorted,
                cfg.maxProducts,
                pack.seeds
              )
            }
            if (!pack.sorted.length) {
              contentEl.innerHTML = ""
              clearCartBestSellerContentBusy(contentEl)
              var empty = document.createElement("p")
              empty.className = "cart-best-seller-empty"
              empty.textContent =
                cfg.emptyText || "No recommendations available."
              contentEl.appendChild(empty)
              return
            }
            return renderProductRecommendationsCarousel(
              pack.sorted,
              cfg,
              contentEl
            ).then(function () {
              if (!contentEl.querySelector(".product-item")) {
                contentEl.innerHTML = ""
                clearCartBestSellerContentBusy(contentEl)
                var noCards = document.createElement("p")
                noCards.className = "cart-best-seller-empty"
                noCards.textContent =
                  cfg.emptyText || "No recommendations available."
                contentEl.appendChild(noCards)
              }
            })
          })
      })
      .catch(function () {
        if (dominantEl) {
          dominantEl.hidden = true
          dominantEl.textContent = ""
        }
        if (contentEl) {
          contentEl.innerHTML = ""
          clearCartBestSellerContentBusy(contentEl)
          var err = document.createElement("p")
          err.className = "cart-best-seller-empty"
          err.textContent = cfg.errorText || "Could not load recommendations."
          contentEl.appendChild(err)
        }
      })
  }

  var cartUpdateListenerBound = false

  function bindCartUpdateListenerOnce() {
    if (cartUpdateListenerBound || window.__cartBestSellerCartUpdateBound)
      return
    cartUpdateListenerBound = true
    window.__cartBestSellerCartUpdateBound = true
    document.addEventListener("cart-update", function () {
      document
        .querySelectorAll("[data-cart-best-seller-root]")
        .forEach(function (root) {
          syncOneRootFromDom(root)
        })
    })
  }

  function parseConfigFromEl(cfgEl) {
    if (!cfgEl || !cfgEl.textContent) return null
    try {
      var cfg = JSON.parse(cfgEl.textContent)
      var maxP = Number(cfg.maxProducts)
      if (isNaN(maxP)) maxP = 5
      cfg.maxProducts = Math.max(1, Math.min(CART_REC_MAX_PRODUCTS, maxP))
      return cfg
    } catch (e) {
      return null
    }
  }

  function syncOneRootFromDom(root) {
    var configId = root.getAttribute("data-config-id")
    var cfgEl = configId ? document.getElementById(configId) : null
    var cfg = parseConfigFromEl(cfgEl)
    if (!cfg) return
    syncCartRecommendationsFromServer(root, cfg)
  }

  function bootCartRecommendationsSection() {
    bindCartUpdateListenerOnce()
    var roots = document.querySelectorAll("[data-cart-best-seller-root]")
    if (!roots.length) return
    roots.forEach(function (root) {
      if (root.getAttribute("data-cart-rec-booted") === "1") return
      root.setAttribute("data-cart-rec-booted", "1")
      syncOneRootFromDom(root)
    })
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      bootCartRecommendationsSection
    )
  } else {
    bootCartRecommendationsSection()
  }
})()
